module.exports = __webpack_public_path__ + "components/home-header/static/header-1--huge@2x-1ea7b1b8a2938044357d50eb7877958d.jpg";